var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overview" },
    [
      _vm.description
        ? [
            _c("markdown-formatter", {
              staticClass: "description__markdown-formatter",
              attrs: { source: _vm.description }
            })
          ]
        : [
            _c("p", { staticClass: "text danger" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.i18n.cm_error_occured()) + "\n    "
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c76459a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c76459a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.DescriptionTab.vue
// module id = NZ50
// module chunks = 1